import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { AuthService } from "../core/auth.service";

@Component({
  selector: "app-profile-page",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule],
  templateUrl: "./profile-page.component.html",
  styleUrls: ["./profile-page.component.scss"],
})
export class ProfilePageComponent {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  readonly supplier = this.auth.supplier;

  logout() {
    void this.auth.logout().then(() => this.router.navigate(["/login"]));
  }
}
